import MoreInfoView from 'text!./views/more-info.html';
import PolicySelectGatewayCtrl from './controllers/PolicySelectGatewayCtrl';
import PolicySelectGatewayView from 'text!./views/policy-select.html';
import PolicyService from './services/PolicyService';
import 'edge/fnol/app';

export default angular.module('edge.gateway.fnol.common.app', ['edge.fnol.app']).config(['$provide', function ($provide) {
    $provide.decorator('fnol.LoadSaveService', ['$delegate', 'JsonRPCService', function ($delegate, JsonRPCService) {
        var origGetClaim = $delegate.getClaim;
        $delegate.getClaim = function (callGroups, claimNumber) {
            return origGetClaim(callGroups, claimNumber).then(function (claim) {
                // Error handling? Who cares, user already sees the data.
                JsonRPCService.send('cc', 'gatewayclaim/claim', 'addRecentlyViewedClaim', [claim.claimNumber]);
                return claim;
            });
        };
        return $delegate;
    }]);
}]).factory('fnol.PolicyService', PolicyService).value('fnol.endpointConfig', {
    'loadSaveEndpoint': 'gatewayfnol/fnol'
})

// override base FNOL configuration for gateway portal
.run(['$state', function ($state) {
    var moreInfoState = $state.get('moreInfo');
    moreInfoState.template = MoreInfoView;
    var policySelect = $state.get('policySelect');
    policySelect.controller = PolicySelectGatewayCtrl;
    policySelect.template = PolicySelectGatewayView;
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/fnol/common/app.js
// module id = 1774
// module chunks = 0